import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/p/$id/folder/$folderId/$slug')({
  component: PublicFolderLayout,
});

function PublicFolderLayout() {
  return <Outlet />;
}
